import logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { CartLineCollectionModel, ProductInventoryDto } from "@insite/client-framework/Types/ApiModels";
import buildAddToCartCollectionTracking from "@MasterBluePrint/Tracking/AddToCart/addToCartCollectionTrackingBuilder";
import { getCurrentUrl, getDataLayer } from "@MasterBluePrint/Tracking/trackingHelper";

const addToCartCollectionTracking = (products: CartLineCollectionModel, state: ApplicationState, productInventoryDtos?: ProductInventoryDto[]) => {
    try {
        const currentUrl = getCurrentUrl();
        const payload = buildAddToCartCollectionTracking(products, state, currentUrl, productInventoryDtos);

        const dataLayer = getDataLayer();
        dataLayer.push({ ecommerce: null });
        dataLayer.push(payload);
    } catch (error) {
        logger.debug(error);
    }
};

export default addToCartCollectionTracking;